module.exports = __webpack_public_path__ + "img/baiyingzi2.c9d221db.png";